export default "__VITE_ASSET__C1nLY_WF__"